module.exports = require("material-ui/Menu");


//////////////////
// WEBPACK FOOTER
// external "material-ui/Menu"
// module id = 360
// module chunks = 0